import React from 'react';

export const ModalContext = React.createContext({});
ModalContext.displayName = 'Modal';

export const ModalContextProviderOverlay = ({ children }) => (
  <ModalContext.Provider value={{ isModalOverlay: true }}>{children}</ModalContext.Provider>
);

export const ModalContextProviderBackground = ({ children }) => (
  <ModalContext.Provider value={{ isModalOverlay: false }}>{children}</ModalContext.Provider>
);
